import { Routes } from "@angular/router";
import { AppPage } from "jk-service";
import { Taxpq80Component } from "./taxpq80/taxpq80.component";

export const taxPages: AppPage[] = [
//  { title: 'TURNKEY資料查詢(TAXPQ80)', url: '/taxpq80', id: 'taxpq80', isCheckPower: true },
  { title: 'TURNKEY資料查詢', url: '/tax/taxpq80', id: 'taxpq80', isCheckPower: true },
];

export const taxRoutes: Routes = [
  {  path: 'taxpq80',  component: Taxpq80Component,},
];

